export enum Mutations {
  markNotificationAsRead = 'markNotificationAsRead',
}
